import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export function MaskLine({ children, delay = 0, className = "" }) {
  return (
    <span className="block overflow-hidden">
      <motion.span
        className={`block ${className}`}
        initial={{ y: "112%" }}
        animate={{ y: 0 }}
        transition={{ duration: 1, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function Reveal({ children, delay = 0, y = 28, className = "", testid }) {
  return (
    <motion.div
      data-testid={testid}
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, className = "" }) {
  return (
    <p className={`font-mono text-[10px] uppercase tracking-[0.34em] text-neon/80 sm:text-xs ${className}`}>
      {children}
    </p>
  );
}
